<p-dialog
        [(visible)]="this.visible"
        [modal]="true"
        [header]="'Update Brand'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '500px' }"
        (onHide)="this.close()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-briefcase"></p-inputicon>
                <input
                        pInputText
                        id="brand-name"
                        [(ngModel)]="this.brand.name"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Brand Name"
                />
            </p-iconfield>
            <label for="brand-name">Brand Name <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-tag"></p-inputicon>
                <input
                        pInputText
                        id="label"
                        [(ngModel)]="this.brand.label"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Label (e.g., 'Premium')"
                />
            </p-iconfield>
            <label for="label">Label <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <app-select-or-upload-media [(selectedMedia)]="this.media"></app-select-or-upload-media>
        <p class="text-gray-400 text-xs">With <span class="text-red-500">*</span> marked fields are
            mandatory.</p>
    </div>
    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="this.close()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Update"
                icon="pi pi-check"
                (click)="updateBrand()"
                [disabled]="this.saveDisabled"
                [loading]="this.loading"
        ></p-button>
    </div>
</p-dialog>
